import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function RequireUser() {
  const { hasToken } = useAuth();
  const location = useLocation();
  if (!hasToken) {
    return <Navigate to="/giris" state={{ from: location }} replace />;
  }
  return <Outlet />;
}
